import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { useLoading } from "../../context/LoadingContext";
import { useNavigate } from "react-router-dom";

const useGetData = (url, body = null) => {
  const { isLoading, setLoading } = useLoading();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);
  const navigate = useNavigate();

  const refetch = useCallback(() => {
    setRefreshIndex(prev => prev + 1);
  }, []);

  useEffect(() => {
    if (!url) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const accessToken = sessionStorage.getItem("accessToken");
        const headers = accessToken ? { Authorization: `${accessToken}` } : {};

        let response;

        if (body) {
          response = await axios.post(url, body, { headers });
        } else {
          response = await axios.get(url, { headers });
        }

        setData(response.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url, body, refreshIndex]);

  return { data, isLoading, error, refetch };
};

export default useGetData;


